module.exports = __webpack_public_path__ + "img/信力.png";